import React, { Component } from 'react'
import styled from 'styled-components'
import { Container, Row, Col, media } from 'styled-bootstrap-grid'

const Wrapper = styled.div`
  position: relative;
  overflow: hidden;
`

const StyledContainer = styled(Container)`
  ${media.xs`
    padding: 0 !important;
  `}
`

const VideoContainer = styled.div`
  margin-top: ${props => props.theme.navHeight * 1.5}px;
  position: relative;
  z-index: 1;

  ${media.xs`
    height: 90vh;
    width: 100%;
    overflow: hidden;
    margin-top: 0;
  `}
`

const Video = styled.video`
  width: 100%;
  height: auto;

  ${media.xs`
    height: 100%;
    width: auto;
    position: absolute;
    left: 0;
    transform: translateX(-50%);
  `}
`

const TextContainer = styled.div`
  position: absolute;
  width: 50%;
  top: 0;
  left: 0;
  margin: 50px 0 0 50px;
  border-top: 1px solid white;
  color: white;
  z-index: 2;

  ${media.xs`
    width: calc(100% - 40px);
    margin: 0;
    top: auto;
    bottom: 0;
    margin: 0 20px;
  `}
`

const CTA = styled.h4`
  font-size: 12px;
  font-weight: 500;
  text-transform: uppercase;
`

const Title = styled.h1`
  font-size: 80px;
  font-weight: 300;
  line-height: 80px;

  ${media.xs`
    font-size: 40px;
    line-height: 40px;
  `}
`

const Background = styled.div`
  background: ${props => props.theme.colors.primary};
  height: calc(50% + ${props => props.theme.navHeight}px);
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;

  ${media.xs`
    display: none;
  `}
`

export default class HeaderVideo extends Component {
  render() {
    const {
      cta,
      title,
      video
    } = this.props

    return(
      <Wrapper>
        <StyledContainer fluid>
          <Row>
            <Col col={12}>
              <VideoContainer>
                <TextContainer>
                  <CTA>{cta}</CTA>
                  <Title>{title}</Title>
                </TextContainer>
                <Video
                  src={video.sourceUrl}
                  autoPlay
                  muted
                  loop
                />
              </VideoContainer>
            </Col>
          </Row>
        </StyledContainer>
        <Background />
      </Wrapper>
    )
  }
}



// WEBPACK FOOTER //
// ./src/ui/components/modules/HeaderVideo/index.js